import axios from 'axios';
import { ACCESS_TOKEN, API_BASE_URL } from '../constants';

export function useApiClient() {
  const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  apiClient.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem(ACCESS_TOKEN);

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(normalizeApiError(error))
  );

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const normalizedError = normalizeApiError(error);

      if (normalizedError.status === 401) {
        localStorage.removeItem(ACCESS_TOKEN);
        window.location.reload();
      }

      return Promise.reject(normalizedError);
    }
  );

  return apiClient;
}

function normalizeApiError(error) {
  if (!error.response) {
    return {
      status: null,
      message: 'Network error. Please check your connection.',
      businessErrorCode: null,
      businessExceptionDescription: null,
      validationError: [],
      errors: {},
      raw: error,
    };
  }

  const { status, data } = error.response;

  return {
    status,
    businessErrorCode: data?.businessErrorCode ?? null,
    businessExceptionDescription: data?.businessExceptionDescription ?? null,
    message:
      data?.error ||
      data?.businessExceptionDescription ||
      data?.message ||
      'Unexpected error occurred.',
    validationError: data?.validationError ?? [],
    errors: data?.errors ?? {},
    raw: data,
  };
}